import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import Toast from './Toast';

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [message, setMessage] = useState('');
  const [type, setType] = useState(undefined);
  const [actionLabel, setActionLabel] = useState(undefined);
  const [onAction, setOnAction] = useState(undefined);

  const showToast = useCallback((nextMessage, nextType, nextOptions) => {
    setMessage(nextMessage || '');
    setType(nextType);
    if (nextOptions?.actionLabel && nextOptions?.onAction) {
      setActionLabel(nextOptions.actionLabel);
      setOnAction(() => nextOptions.onAction);
    } else {
      setActionLabel(undefined);
      setOnAction(undefined);
    }
  }, []);

  const clearToast = useCallback(() => {
    setMessage('');
    setType(undefined);
    setActionLabel(undefined);
    setOnAction(undefined);
  }, []);

  const value = useMemo(
    () => ({ showToast, clearToast }),
    [showToast, clearToast],
  );

  return (
    <ToastContext.Provider value={value}>
      {children}
      <div className="toast-host" aria-live="polite">
        <Toast
          message={message}
          type={type}
          actionLabel={actionLabel}
          onAction={onAction}
        />
      </div>
    </ToastContext.Provider>
  );
}

const NOOP_TOAST = Object.freeze({
  showToast: () => {},
  clearToast: () => {},
});

export function useToast() {
  const ctx = useContext(ToastContext);
  return ctx || NOOP_TOAST;
}
